module.exports = __webpack_public_path__ + "img/133.2.f80ca94f.png";